
export default [
    {date: "17/10",
    description: "Checkpoint 1",
    place: "",
    status: "/assets/img/icones/check.ico",
    id: "item1",
    speaker: "Abertura e inscrição dos grupos",
    time: "18:30",
    link_classificados: '/InscritosHackaPUC2023.pdf',
    },

    {date: "18/10",
    description: "Checkpoint 2",
    place: "Entrega",
    speaker: "Prazo final para entrega do formulário do projeto escrito",
    time: "13:00",
    status: "/assets/img/icones/check.ico",
    id: "item2",
    link: "https://forms.office.com/r/4E0SYQbwyr",
    link_classificados: 'ClassificadosCP2.pdf',
    },


    {date: "18/10",
    description: "Checkpoint 3",
    place: "Entrega",
    speaker: "Prazo final para a entrega do primeiro protótipo desenhado",
    time: "22:00",
    status: "/assets/img/icones/check.ico",
    id: "item3",
    link: "https://forms.office.com/r/LyX8Pt2gSC",
    link_classificados: 'CP3.pdf',
    },

    
    {date: "19/10",
    description: "Checkpoint 4",
    place: "Entrega",
    speaker: "MVP",
    time: "14:00",
    status: "/assets/img/icones/remove.ico",
    id: "item4",
    link: "https://forms.office.com/r/4A31eL1Ys4",
    link_classificados: '',
    },


    {date: "19/10",
    description: "Checkpoint 5",
    place: "Pitch deve ser apresentado para a banca em no maximo 5 minutos",
    speaker: "Apresentação dos pitchs e encerramento",
    time: "18:30",
    status: "/assets/img/icones/remove.ico",
    id: "item5",
    link_classificados: '',
    },

]



